import { Component, EventEmitter, Input, Output, OnInit, OnChanges } from "@angular/core";
import { ObjectTypes } from "../../../enums/objectTypes";
import { RAGBreakdown } from "../../../models/rag/ragBreakdown";
import { FilterTypes } from "../../../enums/filterTypes";
import { ObjectEventEmitters } from "../../../events/object.events";
import { Router } from "@angular/router";
import { Account } from "../../../models/account";
import { AuthenticationService } from "../../../services/authentication.service";
import { FilterUtilities } from "../../../utilities/filter.utilities";
import { T } from 'src/assets/i18n/translation-keys';
import { UrlService } from "../../../services/url.service";

@Component({
    selector: 'app-details-breakdown-widget',
    templateUrl: './details-breakdown-widget.component.html',
    styleUrls: ['./details-breakdown-widget.component.scss'],
    standalone: false
})
export class DetailsBreakdownWidgetComponent implements OnInit, OnChanges {
  @Input() showEmptyState: boolean = true;
  @Input() title: string = '';
  @Input() viewAllText: string = 'View All';
  @Input() objectType: ObjectTypes;
  @Input() showCards: boolean = true;
  @Input() showPercentageOfCompletionInCards: boolean = false;
  @Input() showPercentageOfCompletionInHeader: boolean = false;
  @Input() showTotalItemsInHeader: boolean = false;
  @Input() showNumberOfItemsInCards: boolean = false;
  @Input() ragBreakdownItems: { title: string, ragBreakdowns: RAGBreakdown[], count: number }[] = [];
  @Input() headerCount: number = 0;
  @Input() detailsItemFilterType: FilterTypes;
  @Input() detailsItemId: number;
  @Input() icon: string;
  @Output() onEmptyStateAction = new EventEmitter<void>();

  totalItems = 0;
  private account: Account;

  public readonly T = T;

  constructor(
    private readonly objectEventEmitters: ObjectEventEmitters,
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService,
    private readonly urlService: UrlService
  ) {

  }

  ngOnInit(): void {
    this.account = this.authenticationService.getCurrentAccount();

    this.totalItems = this.ragBreakdownItems.reduce((acc, item) => {
      return acc + (item.ragBreakdowns ? item.ragBreakdowns.reduce((sum, rag) => sum + rag.count, 0) : 0);
    }, 0);
  }

  ngOnChanges(): void {
    this.totalItems = this.ragBreakdownItems.reduce((acc, item) => {
      return acc + (item.ragBreakdowns ? item.ragBreakdowns.reduce((sum, rag) => sum + rag.count, 0) : 0);
    }, 0);
  }

  viewAll(objectType: ObjectTypes): void {
    const eventFilter = FilterUtilities.GenerateFilter(this.detailsItemFilterType, String(this.detailsItemId), '', null, null, objectType);

    this.objectEventEmitters.broadcastHeaderFiltersExternalAdded([eventFilter]);
    this.urlService.navigateToListPage(objectType, 0, false);
  }
}
